import {Fragment} from "react";
import ComponentTabsContent from "../ComponentTabs/ComponentTabsContent";
import ComponentTabsHeader from "../ComponentTabs/ComponentTabsHeader";
import InputNumberEditTab from "./InputNumberEditTab";
import InputNumberOptionsTab from "./InputNumberOptionsTab";

export function InputNumberEdit({component_key, attributes, dispatch}) {
  return (
    <Fragment>
      <ComponentTabsHeader
        component_key={component_key}
        attributes={attributes}
        dispatch={dispatch}
      />
      <ComponentTabsContent
        component_key={component_key}
        attributes={attributes}
        dispatch={dispatch}
        EditTab={InputNumberEditTab}
        OptionTab={InputNumberOptionsTab}
      />
    </Fragment>
  );
}

export default InputNumberEdit;
